export const numberToLetter = (index: number): string => {
  return String.fromCharCode(65 + index)
}
